/* eslint-env browser, node */

// In non-production runs (e.g. `gatsby develop` / `start:production`) the offline
// plugin is not loaded, so any service worker left over from a previous production
// build keeps serving a stale bundle and breaks the app shell. Unregister it and
// purge its caches so the dev server's assets are used.
exports.onClientEntry = () => {
  if (process.env.NODE_ENV === "production") {
    return;
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }

  if (window.caches && typeof window.caches.keys === "function") {
    window.caches.keys().then((keys) => {
      keys.forEach((key) => window.caches.delete(key));
    });
  }
};

const APP_UPDATE_RELOAD_UNBLOCKED_EVENT = "coinmiles:app-update-reload-unblocked";

const reloadForAppUpdate = () => {
  window.location.reload();
};

exports.onServiceWorkerUpdateReady = () => {
  if (window.__coinmilesBlockAppUpdateReload) {
    window.__coinmilesPendingAppUpdateReload = true;
    window.addEventListener(
      APP_UPDATE_RELOAD_UNBLOCKED_EVENT,
      () => {
        if (
          window.__coinmilesPendingAppUpdateReload &&
          !window.__coinmilesBlockAppUpdateReload
        ) {
          reloadForAppUpdate();
        }
      },
      { once: true },
    );
    return;
  }

  reloadForAppUpdate();
};

exports.onRouteUpdate = ({ prevLocation }, { trackPage, trackPageDelay = 50 }) => {
  if (!trackPage) {
    return;
  }

  function trackSegmentPage() {
    // Adding a delay (defaults to 50ms when not provided by plugin option `trackPageDelay`)
    // ensure that the segment route tracking is in sync with the actual Gatsby route
    // (otherwise you can end up in a state where the Segment page tracking reports
    // the previous page on route change).
    const delay = Math.max(0, trackPageDelay);

    window.setTimeout(() => {
      window.analytics && window.analytics.page(document.title);
    }, delay);
  }

  // This `if/then` logic relates to the `delayLoad` functionality to help prevent
  // calling `trackPage` twice. If you don't use that feature, you can ignore.
  // Here call `trackPage` only _after_ we change routes (on the client).
  if (prevLocation && window.segmentSnippetLoaded === false) {
    window.segmentSnippetLoader(() => {
      trackSegmentPage();
    });
  } else {
    trackSegmentPage();
  }
};
